import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const MessageContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: var(--padding-1) 0;
	font-size: var(--paragraph3-font-size);

	> div.flexRow {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		> p.conflictingRule {
			background-color: var(--red);
			color: var(--white);
			padding: var(--padding-2) var(--padding-3);
			margin: var(--margin-2) var(--margin-2) 0 0;
			border-radius: var(--small-border-radius);
			body[dir='rtl'] & {
				margin: var(--margin-2) 0 0 var(--margin-2);
			}
		}
	}
`;

export const ResultContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 1rem;
	width: 100%;
`;
export const ResultContainerRunFeasiblity = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 1rem;
	width: 100%;
`;
export const RowContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 0.5rem;
	width: 100%;
	flex: 1;
	&.dc {
		align-items: center;
	}
	@media ${Breakpoints.mobileLandscape} {
		align-items: center;
		&.outer {
			flex-direction: column;
		}
	}
	& > .form-item {
		flex: 1 1 auto;
	}
`;
export const FeasibilityResultContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--padding-3);
`;
